<template>
  <v-container>
    <v-row justify="center">
      <v-col cols="12" sm="2">
        <div class="text-subtitle-2 " v-text="$t('Admin.sort')"></div>
        <v-select :items="sortItems" v-model="sortFilter" solo></v-select>
      </v-col>
      <v-col cols="12" sm="2">
        <div class="text-subtitle-2 " v-text="$t('Admin.type')"></div>
        <v-select
          clearable
          :items="['Name','Id']"
          :placeholder="$t('Admin.enterType')"
          v-model="filterAttribute"
          solo
        ></v-select>
      </v-col>
      <v-col cols="12" sm="6">
        <div class="text-subtitle-2 " v-text="$t('Admin.filter')"></div>
        <v-text-field :placeholder="$t('Admin.enterFilter')" solo v-model="filter"></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col class="text-center">
        <v-btn class="mb-5" tile outlined color="primary" @click="$emit('create')">
          <v-icon left>mdi-plus-circle</v-icon>
          {{$t('DataHome.create')}}
        </v-btn>
      </v-col>
    </v-row>
    <template v-if="loading">
      <v-row justify="center">
        <v-col>
          <div class="text-center mt-5">
            <v-progress-circular indeterminate color="primary"></v-progress-circular>
          </div>
        </v-col>
      </v-row>
    </template>
    <template v-else>
      <v-row>
        <v-col v-for="net in networksArray" :key="net.id" cols="12" sm="4">
          <v-hover v-slot:default="{ hover }">
            <v-flex>
            <v-card
              :id="net.id"
              style="cursor: pointer;"
              :elevation="hover ? 10 : 2"
              class="mx-auto"
              max-width="344"
              @click="sendChoosenNetwork($event)"
            >
                <v-container>
                  <p class="headline text-wrap ma-3">{{net.name}}</p>
                  <v-list-item three-line>
                    <v-list-item-content>
                  <div class="subtitle-2 mb-2 text-wrap text-uppercase">{{net.id}}</div>

                  <v-list-item-subtitle>{{net.description}}</v-list-item-subtitle>
                  <v-list-item-subtitle>{{$t('Admin.countusers')}}{{net.users.length}}</v-list-item-subtitle>
                  <v-list-item-subtitle>{{$t('Admin.countdevices')}}{{net.devices.length}}</v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                </v-container>
              </v-card>
            </v-flex>
          </v-hover>
        </v-col>
      </v-row>
    </template>
    <v-alert type="warning" v-if="!loading && noNetwork">{{$t('Admin.nonetworks')}}</v-alert>
  </v-container>
</template>

<script>
import axios from "axios";
import tokenStore from "../../store/TokenStore";

export default {
  props: {
    source: String
  },
  data: () => ({
    networks: [],
    noNetwork: true,
    loading: true,
    filterAttribute: undefined,
    filter: "",
    sortFilter: "",
    sortItems: []
  }),
  computed: {
    networksArray: function() {
      let array = this.networks;
      if (this.filterAttribute != undefined) {
        array = [];
        this.networks.forEach(net => {
          if (
            net[
              this.filterAttribute.charAt(0).toLowerCase() +
                this.filterAttribute.slice(1)
            ]
              .toLowerCase()
              .startsWith(this.filter.toLowerCase())
          ) {
            array.push(net);
          }
        });
      }
      function compareWithParam(param) {
        return function compare(d1, d2) {
          let a = d1.name;
          let b = d2.name;
          if (param == "Id") {
            a = d1.id;
            b = d2.id;
          }
          if (a < b) return -1;
          if (a > b) return 1;
          return 0;
        };
      }

      if (array != undefined) {
        switch (this.sortFilter) {
          default:
            return array.sort(compareWithParam(this.filterAttribute));

          case this.$t("Admin.ascending"):
            return array.sort(compareWithParam(this.filterAttribute));

          case this.$t("Admin.descending"):
            return array.sort(compareWithParam(this.filterAttribute)).reverse();
        }
      } else {
        return array;
      }
    }
  },

  methods: {
    sendChoosenNetwork: function(event) {
      let index = this.networks.findIndex(e => {
        return e.id == event.currentTarget.id;
      });
      this.$emit("choosennetwork", this.networks[index]);
    }
  },

  beforeMount: function() {
    this.sortItems = [
      this.$t("Admin.ascending"),
      this.$t("Admin.descending")
    ];
    this.sortFilter = this.sortItems[0];
    axios
      .get(process.env.VUE_APP_API_ADDR + "/api/network", {
        headers: { Authorization: tokenStore.getToken() }
      })
      .then(res => {
        if (res.data.networks.length == 0) {
          this.noNetwork = true;
          this.loading = false;
        } else {
          this.noNetwork = false;
          res.data.networks.forEach(net => {
            axios
              .get(
                process.env.VUE_APP_API_ADDR +
                  "/api/network/" +
                  net.id +
                  "/users",
                {
                  headers: { Authorization: tokenStore.getToken() }
                }
              )
              .then(res => {
                if (res.data.success) {
                  net.users = res.data.users;
                  axios
                    .get(
                      process.env.VUE_APP_API_ADDR +
                        "/api/network/" +
                        net.id +
                        "/devices",
                      {
                        headers: { Authorization: tokenStore.getToken() }
                      }
                    )
                    .then(res => {
                      if (res.data.success) {
                        net.devices = res.data.devices;
                        this.networks.push(net);
                      }
                    })
                    .catch(err => {
                      console.log(err);
                      tokenStore.refreshToken();
                    });
                }
              })
              .catch(err => {
                console.log(err);
                tokenStore.refreshToken();
              });
          });
          this.loading = false;
        }
      })
      .catch(err => {
        console.log(err);
        tokenStore.refreshToken();
      });
  }
};
</script>
